import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { ModalAdjustCommissionComponent } from 'src/app/shared/modal-commission-adjust/modal-commission-adjust.component';
import { CommissionAdjustment } from 'src/app/model/commission-adjustment.model';
import Swal from 'sweetalert2';
import { ComisionSimuladorService } from 'src/app/services/comision-simulador.service';
import { CatComponentService } from 'src/app/services/cat-component.service';
import { AuthService } from "src/app/services/auth.service";
import { CumplimientoMetasService } from 'src/app/services/cumplimiento-metas.service';

interface CommissionGroup {
  id: string;
  description: string;
}

interface Tab {
  id: number;
  title: string;
  target: any[];
}

@Component({
  selector: 'app-comisiones-simulador',
  templateUrl: './comisiones-simulador.component.html',
  styleUrls: ['./comisiones-simulador.component.css']
})
export class ComisionesSimuladorComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  @ViewChild("nav", { static: false })
  nav: any;

  // Propiedades principales
  viewStatus: number = 0;
  loading: number = 0;
  simulate: boolean = true;
  typeConsult: string = 'simulate';
  active: number = 0;

  // Catálogos y selecciones
  commissionGroupCatalog: CommissionGroup[] = [];
  selectedCommissionGroup: CommissionGroup | null = null;

  // Rango de fechas con hora (sin segundos)
  startDate: NgbDateStruct | null = null;
  startTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  endTime: NgbTimeStruct = { hour: 23, minute: 59, second: 59 };
  maxDate: NgbDateStruct;

  // Tabs
  tabs: Tab[] = [];

  // DataTable
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  private botonSimular: boolean = false;
  private botonCalcularMetas: boolean = false;

  aplicarRetenciones: boolean = false;
  aplicarLiberaciones: boolean = false;
  aplicarMetas: boolean = false;
  aplicarMetasAutorizadas: boolean = false;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private comisionSimuladorService: ComisionSimuladorService,
    private catComponentService: CatComponentService,
    private auth: AuthService,
    private cumplimientoMetasService: CumplimientoMetasService
  ) { }

  ngOnInit(): void {
    this.initializeComponent();
    this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
      elementGrant.data.filter(el => el.component === "app-comisiones-simulador" && this.auth.getUserRoles().includes(el.role))
        .map(el => {
          if ("boton-calculo-metas" === el.description) {
            this.botonCalcularMetas = el.active;
          } else if ("boton-simular-generar" === el.description) {
            this.botonSimular = el.active
            console.log("Botn service: ", this.botonSimular);
          }
        });
    });
  }

  private initializeComponent(): void {
    this.setMaxDate();
    this.loadCommissionGroups();
    this.initializeDataTable();
  }

  private setMaxDate(): void {
    const today = new Date();
    this.maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
  }

  private loadCommissionGroups(): void {
    this.commissionGroupCatalog = [
      { id: "1", description: "ASESORES" },
      { id: "2", description: "COORDINADORES" },
      { id: "3", description: "REGIONAL Y GERENTES" },
    ];

    if (this.commissionGroupCatalog.length > 0) {
      this.selectedCommissionGroup = null;
    }

    this.viewStatus = 1;
  }

  private initializeDataTable(): void {
    this.dtOptions = {
      order: [],
      responsive: true,
      columnDefs: [
        { responsivePriority: 1, width: 100, targets: -1 },
      ],
      select: 'single',
      bLengthChange: true,
      searching: true,
      dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: [
        {
          text: 'Excel',
          action: () => {
            this.exportToExcel();
          }
        }
      ],
      autoWidth: false,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }
    };
  }

  onCommissionGroupChange(event: any): void {
    if (event) {
      this.selectedCommissionGroup = event;
      console.log('Grupo de comisión seleccionado:', this.selectedCommissionGroup);
    }
  }

  onStartDateChange(date: NgbDateStruct): void {
    this.startDate = date;
  }

  toggleSimulateGenerate(): void {
    this.simulate = !this.simulate;
    this.aplicarRetenciones = !this.simulate;
    this.aplicarLiberaciones = !this.simulate;
    this.aplicarMetas = false;
    console.log('Modo cambiado a:', this.simulate ? 'SIMULAR' : 'GENERAR');
  }

  /**
   * Formatea fecha y hora en formato ISO: YYYY-MM-DD HH:mm:ss (sin segundos mostrados)
   */
  private formatDateTime(date: NgbDateStruct, time: NgbTimeStruct): string {
    const year = date.year;
    const month = date.month.toString().padStart(2, '0');
    const day = date.day.toString().padStart(2, '0');
    const hour = time.hour.toString().padStart(2, '0');
    const minute = time.minute.toString().padStart(2, '0');
    const second = time.second.toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  /**
   * Valida que el rango de fechas sea correcto
   */
  private validateDateRange(): boolean {
    if (!this.startDate) {
      this.toastr.warning('Selecciona una fecha de cobro');
      return false;
    }

    const start = new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day,
      this.startTime.hour, this.startTime.minute, 0);
    const end = new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day,
      this.endTime.hour, this.endTime.minute, 59);

    if (start > end) {
      this.toastr.warning('La fecha de inicio no puede ser mayor a la fecha de fin');
      return false;
    }

    return true;
  }

  /**
   * Genera el título de la pestaña con el rango de fechas
   */
  private generateTabTitle(): string {
    const startStr = this.formatDateTime(this.startDate!, this.startTime);
    const endStr = this.formatDateTime(this.startDate!, this.endTime);
    return `ASESOR INTERNO / ALIADO COMERCIAL (${startStr} - ${endStr})`;
  }

  // ==================== SIMULADOR DE COMISIONES ====================
  commissionSimulator(): void {
    if (!this.selectedCommissionGroup) {
      this.toastr.warning('Selecciona un grupo de comisión');
      return;
    }

    if (!this.validateDateRange()) {
      return;
    }

    this.loading = 1;

    const payload = {
      startDate: this.formatDateTime(this.startDate!, this.startTime),
      endDate: this.formatDateTime(this.startDate!, this.endTime),
      esSimulacion: this.simulate,
      aplicarRetenciones: this.aplicarRetenciones,
      aplicarLiberaciones: this.aplicarLiberaciones,
      aplicarMetas: this.aplicarMetas,
      aplicarMetasAutorizadas: this.aplicarMetasAutorizadas
    };

    this.comisionSimuladorService
      .calculateCommissionsByDateRange(payload)
      .subscribe({
        next: (resp: any) => {
          if (resp && resp.codeHttpStatus === 200 && resp.data) {
            const sessionId = resp.data;
            console.log('SessionId recibido:', sessionId);
            this.monitorearTarea(sessionId, 'simulate');
          } else {
            this.toastr.error('Error al iniciar el cálculo de comisiones');
            this.loading = 0;
          }
        },
        error: (error: any) => {
          console.error('Error al iniciar cálculo de comisiones:', error);
          this.toastr.error('Ha ocurrido un problema al intentar iniciar el cálculo');
          this.loading = 0;
          this.typeConsult = 'error';
        }
      });
  }

  // ==================== GENERADOR DE COMISIONES ====================
  commissionGenerator(): void {
    if (!this.selectedCommissionGroup) {
      this.toastr.warning('Selecciona un grupo de comisión');
      return;
    }

    if (!this.validateDateRange()) {
      return;
    }

    Swal.fire({
      icon: 'warning',
      html: `
        <div style="text-align: center; padding: 20px 10px;">
          <p style="color: #666; font-size: 16px; line-height: 1.6; margin: 0;">
            Se generarán las <strong>Comisiones</strong> de manera irreversible en el<br>
            rango de fechas seleccionado! ¿Está seguro de generar las <strong>Comisiones</strong>?
          </p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Sí, Generar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#6b7280',
      reverseButtons: false,
      customClass: {
        popup: 'swal2-popup-custom',
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      buttonsStyling: true
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Usuario confirmó la generación de comisiones');
        this.loading = 1;

        // Se agrega las opciones de aplicar retenciones y liberaciones al payload para generación de
        const payload = {
          startDate: this.formatDateTime(this.startDate!, this.startTime),
          endDate: this.formatDateTime(this.startDate!, this.endTime),
          aplicarRetenciones: this.aplicarRetenciones,
          aplicarLiberaciones: this.aplicarLiberaciones,
          aplicarMetas: this.aplicarMetas,
          aplicarMetasAutorizadas: this.aplicarMetasAutorizadas,
          esSimulacion: this.simulate
        };

        console.log('Payload de generación:', payload);

        this.comisionSimuladorService
          .calculateCommissionsByDateRange(payload)
          .subscribe({
            next: (resp: any) => {
              if (resp && resp.codeHttpStatus === 200 && resp.data) {
                const sessionId = resp.data;
                console.log('SessionId recibido para generación:', sessionId);
                this.monitorearTarea(sessionId, 'generate');
              } else {
                this.toastr.error('Error al iniciar la generación de comisiones');
                this.loading = 0;
              }
            },
            error: (error: any) => {
              console.error('Error al iniciar generación de comisiones:', error);
              this.toastr.error('Ha ocurrido un problema al intentar iniciar la generación');
              this.loading = 0;
              this.typeConsult = 'error';
            }
          });
      } else if (result.isDismissed) {
        console.log('Usuario canceló la operación');
      }
    });
  }

  // ==================== MONITOREO DE TAREAS (COMPARTIDO) ====================
  private monitorearTarea(sessionId: string, tipoOperacion: 'simulate' | 'generate'): void {
    const INITIAL_INTERVAL = 2000;
    const TIMEOUT = 15 * 60 * 1000;
    const startTime = Date.now();

    let currentInterval = INITIAL_INTERVAL;
    let timerInterval: any;
    let pollCount = 0;
    let pollingErrorCount = 0;

    const titulo = tipoOperacion === 'simulate' ? 'Simulando comisiones' : 'Generando comisiones';
    const mensajeExito = tipoOperacion === 'simulate'
      ? 'Simulación completada exitosamente'
      : 'Comisiones generadas exitosamente';

    Swal.fire({
      title: titulo,
      html: `
        <div style="text-align: center;">
          <p id="status-text">Estado: <strong>Iniciando...</strong></p>
          <p id="timer-text">Tiempo transcurrido: <strong>0s</strong></p>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();

        timerInterval = setInterval(() => {
          const elapsed = Math.floor((Date.now() - startTime) / 1000);
          const timerElement = document.getElementById('timer-text');
          if (timerElement) {
            const minutes = Math.floor(elapsed / 60);
            const seconds = elapsed % 60;
            timerElement.innerHTML = `Tiempo transcurrido: <strong>${minutes}m ${seconds}s</strong>`;
          }
        }, 1000);

        const polling = () => {
          const elapsedTime = Date.now() - startTime;
          pollCount++;

          if (elapsedTime < 120000) {
            currentInterval = 2000;
          } else if (elapsedTime < 300000) {
            currentInterval = 3000;
          } else {
            currentInterval = 10000;
          }

          let shouldActivateLog = false;
          if (currentInterval === 2000) {
            shouldActivateLog = (pollCount % 15) === 1;
          } else if (currentInterval === 3000) {
            shouldActivateLog = (pollCount % 10) === 1;
          } else if (currentInterval === 10000) {
            shouldActivateLog = (pollCount % 3) === 1;
          }

          const activeLog = shouldActivateLog === true;

          if (elapsedTime > TIMEOUT) {
            clearInterval(timerInterval);
            Swal.close();

            Swal.fire({
              icon: 'error',
              title: 'Tiempo límite excedido',
              html: `
                <div style="text-align: center; padding: 10px;">
                  <p style="color: #666; font-size: 15px; line-height: 1.6; margin-bottom: 15px;">
                    El proceso ha excedido el tiempo límite de espera.
                  </p>
                  <p style="color: #666; font-size: 14px; margin-bottom: 10px;">
                    Por favor, consulta al administrador.
                  </p>
                  <div style="background-color: #f3f4f6; padding: 10px; border-radius: 6px; margin-top: 10px;">
                    <p style="color: #374151; font-size: 13px; margin: 0;">
                      <strong>ID de Sesión:</strong>
                    </p>
                    <p style="color: #6b7280; font-size: 13px; font-family: monospace; margin: 5px 0 0 0;">
                      ${sessionId}
                    </p>
                  </div>
                </div>
              `,
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#ef4444'
            });

            this.loading = 0;
            this.typeConsult = 'error';
            return;
          }

          this.comisionSimuladorService.getTaskStatus(sessionId, activeLog).subscribe({
            next: (resp: any) => {
              if (resp && resp.codeHttpStatus === 200 && resp.data) {
                const taskData = resp.data;
                const status = taskData.status;

                const statusElement = document.getElementById('status-text');
                if (statusElement) {
                  let statusText = '';
                  switch (status) {
                    case 'PENDING':
                      statusText = 'Pendiente';
                      break;
                    case 'IN_PROGRESS':
                      statusText = 'En proceso';
                      break;
                    case 'COMPLETED':
                      statusText = 'Completado';
                      break;
                    case 'FAILED':
                      statusText = 'Fallido';
                      break;
                    default:
                      statusText = status;
                  }
                  statusElement.innerHTML = `Estado: <strong>${statusText}</strong>`;
                }

                if (status === 'COMPLETED') {
                  clearInterval(timerInterval);
                  Swal.close();
                  this.procesarResultadoExitoso(taskData.result, tipoOperacion, mensajeExito);

                } else if (status === 'FAILED') {
                  clearInterval(timerInterval);
                  Swal.close();

                  Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió algo inesperado',
                    html: `
                      <div style="text-align: center; padding: 10px;">
                        <p style="color: #666; font-size: 15px; line-height: 1.6; margin-bottom: 15px;">
                          El proceso se ha detenido, por favor intenta nuevamente y si el problema persiste contacta al administrador.
                        </p>
                        <div style="background-color: #f3f4f6; padding: 10px; border-radius: 6px; margin-top: 10px;">
                          <p style="color: #374151; font-size: 13px; margin: 0;">
                            <strong>ID de Sesión:</strong>
                          </p>
                          <p style="color: #6b7280; font-size: 13px; font-family: monospace; margin: 5px 0 0 0;">
                            ${sessionId}
                          </p>
                        </div>
                      </div>
                    `,
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#ef4444'
                  });

                  this.loading = 0;
                  this.typeConsult = 'error';
                  return;
                } else {
                  setTimeout(polling, currentInterval);
                }
              } else if (resp.codeHttpStatus === 404) {
                clearInterval(timerInterval);
                Swal.close();

                Swal.fire({
                  icon: 'error',
                  title: 'Proceso interrumpido',
                  html: `
                    <div style="text-align: center; padding: 10px;">
                      <p style="color: #666; font-size: 15px; line-height: 1.6; margin-bottom: 15px;">
                        El proceso de espera se ha interrumpido.
                      </p>
                      <p style="color: #666; font-size: 14px; margin-bottom: 10px;">
                        Por favor, consulta al administrador.
                      </p>
                      <div style="background-color: #f3f4f6; padding: 10px; border-radius: 6px; margin-top: 10px;">
                        <p style="color: #374151; font-size: 13px; margin: 0;">
                          <strong>ID de Sesión:</strong>
                        </p>
                        <p style="color: #6b7280; font-size: 13px; font-family: monospace; margin: 5px 0 0 0;">
                          ${sessionId}
                        </p>
                      </div>
                    </div>
                  `,
                  confirmButtonText: 'Entendido',
                  confirmButtonColor: '#ef4444'
                });

                this.loading = 0;
                this.typeConsult = 'error';
                return;
              } else {
                setTimeout(polling, currentInterval);
              }
              pollingErrorCount = 0;
            },
            error: (error: any) => {
              console.error('Error al consultar estado de la tarea:', error);

              pollingErrorCount++;
              console.log(`Error count al consultar estado: ${pollingErrorCount}`);
              if (pollingErrorCount >= 3) {
                clearInterval(timerInterval);
                Swal.close();

                Swal.fire({
                  icon: 'error',
                  title: 'Proceso interrumpido',
                  html: `
                    <div style="text-align: center; padding: 10px;">
                      <p style="color: #666; font-size: 15px; line-height: 1.6; margin-bottom: 15px;">
                        El proceso de espera se ha interrumpido.
                      </p>
                      <p style="color: #666; font-size: 14px; margin-bottom: 10px;">
                        Por favor, consulta al administrador.
                      </p>
                      <div style="background-color: #f3f4f6; padding: 10px; border-radius: 6px; margin-top: 10px;">
                        <p style="color: #374151; font-size: 13px; margin: 0;">
                          <strong>ID de Sesión:</strong>
                        </p>
                        <p style="color: #6b7280; font-size: 13px; font-family: monospace; margin: 5px 0 0 0;">
                          ${sessionId}
                        </p>
                      </div>
                    </div>
                  `,
                  confirmButtonText: 'Entendido',
                  confirmButtonColor: '#ef4444'
                });

                this.loading = 0;
                this.typeConsult = 'error';
                return;
              }

              setTimeout(polling, currentInterval);
            }
          });
        };

        polling();
      },
      willClose: () => {
        clearInterval(timerInterval);
      }
    });
  }

  // ==================== PROCESAMIENTO DE RESULTADOS (COMPARTIDO) ====================
  private procesarResultadoExitoso(
    listCommissionProductEmployee: any,
    tipoOperacion: 'simulate' | 'generate',
    mensajeExito: string
  ): void {
    if (listCommissionProductEmployee != null && listCommissionProductEmployee.length > 0) {
      console.log('Comisiones obtenidas:', listCommissionProductEmployee);

      const tabTitle = this.generateTabTitle();
      let newTabId = 1;

      const existingTab = this.tabs.find(tab => tab.title === tabTitle);
      if (existingTab) {
        this.tabs = this.tabs.filter(tab => tab.title !== tabTitle);
      }

      if (this.tabs.length > 0) {
        const lastTab = this.tabs.reduce((prev, current) =>
          prev.id > current.id ? prev : current
        );
        newTabId = lastTab.id + 1;
      }

      const newTab: Tab = {
        id: newTabId,
        title: tabTitle,
        target: listCommissionProductEmployee
      };

      this.tabs.push(newTab);
      this.active = newTab.id;

      if (listCommissionProductEmployee.some(item => item.calculoHistorico)) {
        Swal.fire({
          icon: 'info',
          title: 'Créditos con cálculo histórico',
          html: `
            <p>
              Se encontraron créditos calculados anteriormente y guardados en el histórico.
              Estos se muestran en el resultado de la simulación.
            </p>
            <p>
              <strong>Importante:</strong> no son tomados en cuenta en la
              <strong style="color:#d33;">generación</strong> del cálculo de comisiones.
            </p>
          `,
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6'
        });
      }
      this.toastr.success(mensajeExito);
    } else {
      this.toastr.info('No hay resultados de comisiones para el rango de fechas seleccionado');
    }

    this.loading = 0;
    this.rerenderDataTable();
    this.typeConsult = tipoOperacion;
  }

  onCloseTab(event: MouseEvent, toRemove: number) {
    this.tabs = this.tabs.filter(tab => tab.id !== toRemove);
    this.nav.select(1);
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  openModal(target) {
    let comisionOriginalFinal = target.commissionAmountFinal;
    console.log("COMISION ORIGINAL FINAL: " + comisionOriginalFinal);

    let commissionAdjustment = new CommissionAdjustment();
    commissionAdjustment.creditId = target.iCreditId;
    commissionAdjustment.employeeId = target.vEmployeeId;
    commissionAdjustment.employeeName = target.vNombreEmpleado;
    commissionAdjustment.capitalAmount = target.MontoCapitalTotal;
    commissionAdjustment.commissionAmount = target.MontoComisionTotal;
    commissionAdjustment.commissionPercent = target.CommissionSchema;
    commissionAdjustment.commissionAdjustmentAmount = target.commissionAdjustmentAmount;
    commissionAdjustment.executionDate = target.executionDate;
    commissionAdjustment.simulated = 1;
    commissionAdjustment.businessLineId = target.businessLineId;
    commissionAdjustment.productId = target.productId;
    commissionAdjustment.enviado = 0;
    commissionAdjustment.CommissionAdjustmentAvalible = null;
    commissionAdjustment.CommissionAdjustmentFree = null;
    commissionAdjustment.iCreditIdMotivo = null;
    commissionAdjustment.comentario = null;
    commissionAdjustment.claveEmpleadoDispersion = null;

    let modalRef = this.modalService.open(ModalAdjustCommissionComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static'
    });

    // Aquí podrías pasar el rango de fechas si lo necesitas en el modal
    const dateRange = `${this.formatDateTime(this.startDate!, this.startTime)} - ${this.formatDateTime(this.startDate!, this.endTime)}`;
    modalRef.componentInstance.simulateDate = dateRange;
    modalRef.componentInstance.selectedCommission = commissionAdjustment;
    modalRef.componentInstance.comisionOriginalFinal = comisionOriginalFinal;

    modalRef.result.then(
      data => console.log(">> DATA: " + data),
      reason => {
        this.viewStatus = 0;
        this.loading = 1;
        console.log(">> REASON: " + reason);
        if (reason != 'failure') {
          target.commissionAdjustmentAmount = reason;
          target.commissionAmountFinal = comisionOriginalFinal + reason;
        }
        this.loading = 0;
        this.viewStatus = 1;
      }
    );
  }

  private rerenderDataTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: any) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.dtTrigger.next(null);
    }
  }

  exportToExcel() {
    const selectedTabId = this.active - 1;
    const comisiones: any = this.tabs[selectedTabId];
    const excelData = {
      name: comisiones.title,
      data: comisiones.target,
      columns: [
        { property: "executionDate", header: "Fecha de Ejecución", order: 0 },
        { property: "ComisionApertura", header: "Comisión Apertura", order: 0 },
        { property: "MontoComisionTotal", header: "Monto Comisión Total", order: 0 },
        { property: "Linea", header: "Línea", order: 0 },
        { property: "commissionAdjustmentAmount", header: "Ajuste de Comisión", order: 0 },
        { property: "ApplyPayment", header: "Pago Aplicado", order: 0 },
        { property: "Seguro", header: "Comisión Seguro", order: 0 },
        { property: "cliente", header: "Cliente", order: 1 },
        { property: "iCreditId", header: "Crédito", order: 2 },
        { property: "vFinancingId", header: "Clave Producto", order: 3 },
        { property: "Fondeador", header: "Nombre Socio", order: 4 },
        { property: "statusSolicitud", header: "Estatus Solicitud", order: 5 },
        { property: "tipoPromocion", header: "Tipo Promoción", order: 6 },
        { property: "periodicidad", header: "Periodo de Pago", order: 7 },
        { property: "Plazo", header: "Plazo Meses", order: 8 },
        { property: "parcialidad", header: "Parcialidad", order: 9 },
        { property: "idGerente", header: "ID G", order: 10 },
        { property: "gerente", header: "Nom Gerente", order: 11 },
        { property: "idSupervisor", header: "ID S", order: 12 },
        { property: "supervisor", header: "Nom Supervisor", order: 13 },
        { property: "vEmployeeId", header: "ID P", order: 14 },
        { property: "vNombreEmpleado", header: "Nom Promotor", order: 15 },
        { property: "FechaCobro", header: "Fecha de Cobro", order: 16 },
        { property: "anio", header: "Año", order: 17 },
        { property: "anio", header: "Año", order: 18 },
        { property: "mes", header: "Mes", order: 19 },
        { property: "mesNombre", header: "Mes", order: 20 },
        { property: "dia", header: "Día", order: 21 },
        { property: "totalPagare", header: "Total Pagare", order: 22 },
        { property: "MontoCapitalTotal", header: "Capital", order: 23 },
        { property: "Convenio", header: "Dependencia", order: 24 },
        { property: "Folio", header: "Folio", order: 25 },
        { property: "sucursal", header: "Sucursal", order: 26 },
        { property: "idSolicitud", header: "Numero Solicitud", order: 27 },
        { property: "Estado", header: "Estado", order: 28 },
        { property: "Region", header: "Zona", order: 29 },
        { property: "colectivo", header: "Colectivo", order: 30 },
        { property: "tipoPromocion", header: "Producto", order: 31 },
        { property: "Empleado", header: "Tipo Asesor", order: 32 },
        { property: "p_especial", header: "P Especial", order: 33 },
        { property: "commissionAmountFinal", header: "Monto Comisión", order: 34 },
        { property: "CommissionSchema", header: "% Comisión", order: 35 },
        { property: "Esquema", header: "Comentario", order: 36 },
        { property: "Categoria", header: "Categorias", order: 37 },
        { property: "nCobradoMesAnt", header: "COL", order: 38 },
        { property: "MedioAdquisicion", header: "Tipo Venta", order: 39 }
      ]
    };

    if (!excelData || !excelData.data || excelData.data.length === 0) return;

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws_data: any[][] = [];

    const orderedColumns = excelData.columns
      .filter((col: any) => col.order !== undefined && col.order !== null && col.order !== 0)
      .sort((a: any, b: any) => a.order - b.order);
    const numCols = orderedColumns.length;

    const firstRow = Array(numCols).fill('');
    firstRow[0] = excelData.name;
    ws_data.push(firstRow);

    ws_data.push(orderedColumns.map((c: any) => c.header));

    excelData.data.forEach((row: any) => {
      const fila: any[] = [];
      orderedColumns.forEach((col: any) => {
        let data = row[col.property] != null && row[col.property] != undefined ? row[col.property] : "";
        switch (col.property) {
          case 'Empleado':
            const tipoEmpleado = data;
            if (tipoEmpleado == "ASESOR INTERNO") {
              data = "Interno"
            } else if (tipoEmpleado == "ALIADO COMERCIAL") {
              data = "Externo"
            } else if (tipoEmpleado == "ASESOR TRAINEE") {
              data = "Trainee"
            }
            break;
          case 'vNombreEmpleado':
            data = data.split(',')[1].trim();
            break;
          case 'Esquema':
            data = row.comentario == undefined || row.comentario == null || row.comentario == "" ? data : data + " | " + row.comentario;
            break;
          case 'nCobradoMesAnt':
            data = data == undefined || data == null || (typeof data === "string" && data == "") ? 0 : data;
            break;
          case 'FechaCobro':
            const [year, month, day] = data.split("-");
            data = `${day}/${month}/${year}`;
            break;
        }
        fila.push(data);
      });
      ws_data.push(fila);
    });

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];
    ws['!cols'] = orderedColumns.map((col: any) => ({ wch: Math.max(col.header.length, 15) }));

    XLSX.utils.book_append_sheet(wb, ws, 'Comisiones');
    XLSX.writeFile(wb, `${excelData.name}.xlsx`);
  }
}
